import React, { useState } from 'react'

const OPTIONS = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' },
    { value: 'maybe', label: 'Maybe' },
]

export default function Hello({ selected = 'maybe' }) {
    const [value, setValue] = useState(selected)

    return (
        <div className="btn-group btn-group-toggle" role="group" aria-label="Hello toggle">
            {OPTIONS.map((option) => (
                <button key={option.value} type="button" className={`btn ${value === option.value ? 'btn-primary active' : 'btn-outline-primary'}`} aria-pressed={value === option.value} onClick={() => setValue(option.value)}>
                    {option.label}
                </button>
            ))}
        </div>
    )
}
